import Backend from 'App/Dataman-Backend';

const { apiUrlInformationSources, apiUrlInformationSourceSnapshots, apiUrlSuffix } = Backend.config;

export const IMAGES_EXTRACTOR_SERVICE_HOST = 'https://images-extractor.winglegroup.com';
export const TEXT_RECOGNITION_SERVICE_HOST = 'https://text-recognition.winglegroup.com';
export const NEWS_QUERY_SERVICE_HOST = 'https://wimsprod.smartcoders.dev';

export const INFORMATION_SOURCES_PATHS = {
  informationSources: apiUrlInformationSources,
  informationSourceSnapshots: apiUrlInformationSourceSnapshots,
  suffix: apiUrlSuffix,
  extractImages: `${IMAGES_EXTRACTOR_SERVICE_HOST}/api/extract-images`,
  textRecognition: `${TEXT_RECOGNITION_SERVICE_HOST}/api/text-recognition`,
  newsQuery: `${NEWS_QUERY_SERVICE_HOST}/api/News/query`,
};
